import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=b74320ca&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74320ca",
  null
  
)

export default component.exports